export enum EnumTipoUsuario {
    Todos = 0,
    Root_MVNO = 1,
    Admin_MVNO = 2,
    Soporte_Técnico = 3,
    Operador = 4,
    Distribuidor = 5
}

export enum EnumAsignacionSim {
    Todos = 0,
    Disponible = 1,
    Asignada = 2,
}

export enum EnumEstatusSim {
    PorAsignar =1,
    Asignada = 2,
    Activa    ,
    Suspendida,
    Tansferida,
    Inactiva,
}


